<template>
    <div>
        <section id="serviceDetailHeader" class="wrapper style3">
            <div class="inner">
                <header class="align-center">
                    <p v-html="detail.subTitle"></p>
                    <h2 v-html="detail.title"></h2>
                </header>
            </div>
        </section>

        <section id="serviceDetail" class="wrapper style2 service-detail">
            <div class="inner">
                <div class="box">
                    <div class="content">
                        <header class="align-center">
                            <p>Visão Global</p>
                        </header>
                        <p v-html="descriptionText"></p>
                        <div class="align-center detail-get-quote">
                            <a class="button special icon fa-comments-o" v-on:click="goToContactForm(detail.id)">OBTER UMA COTAÇÃO</a>
                        </div>
                    </div>
                </div>

                <section class="wrapper style2 other-service-header">
                    <div class="inner">
                        <header class="align-center">
                            <p class="special">Outros Serviços Disponíveis</p>
                        </header>
                    </div>
                </section>
                <div v-for="otherService in otherServices" :key="otherService.id" class="third-to-full other-services">
                    <div class="box">
                        <div class="image fit">
                            <a v-on:click="viewServiceDetail(otherService.id)"><img :src="otherService.img" :alt="otherService.alt" /></a>
                        </div>
                        <div class="content">
                            <header class="align-center">
                                <a v-on:click="viewServiceDetail(otherService.id)"><h3 v-html="otherService.title"></h3></a>
                            </header>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
export default {
    props : {
        services : Array,
		detail : Object,
    },
    methods : {
        viewServiceDetail : function(serviceId) {
			this.$parent.viewServiceDetail(serviceId);
		},
        goToContactForm : function(serviceId) {
            var element = document.querySelector('#contactus');
            var topOffset = element.offsetTop;
            window.scrollTo({top: topOffset, behavior: 'smooth'});

            this.$parent.setContactFormDefault(serviceId);
        }
    },
    computed : {
        descriptionText : function() {
            return this.detail.fullDescription.join("");
        },
        otherServices : function() {
            var aid = this.detail.id;
            return this.services.filter(function(x) { return x.id != aid });
        }
    }
}
</script>

<style scoped>
#serviceDetailHeader {
    margin-top: 0;
}
#serviceDetail .other-service-header {
    padding: 4rem 0 0 0;
}
#serviceDetail .other-services {
    display: inline-block;
    padding: 2rem;
}
#serviceDetail .other-services a {
    cursor: pointer;
    text-decoration: none;
    transition: all 0.9s ease;
}
#serviceDetail .other-services a:hover {
    text-decoration: none;
}
#serviceDetail .other-services a h3 {
    transition: all 0.9s ease;
}
#serviceDetail .other-services a h3:hover {
    font-size: 1.4rem;
}
#serviceDetail .other-services .box {
    border-radius: 25px;
}
#serviceDetail .other-services .box .content {
    padding: 1rem;
}
@media screen and (min-width: 650px) {
    #serviceDetail .other-services .box .content {
        height: 8rem;
        display: table-cell;
        vertical-align: middle;
    }
}
</style>

<style>
#serviceDetail {
	color: #1b1b1b;
}
#serviceDetail header {
	color: #a6a6a6;
	margin-bottom: 1rem;
}
#serviceDetail .detail-get-quote {
	margin-top: 4rem;
}
#serviceDetail .ul-no-bottom-margin ul {
	margin-bottom: 0;
}
#serviceDetail .alt-custom ul li:first-child {
	padding-top: 0.5rem;
}
#serviceDetail .alt-custom ul li:last-child {
	border-bottom: solid 1px;
	border-bottom-color: rgba(0, 0, 0, 0.15);
}

.third-to-full {
	width : 33.33%;
}
@media screen and (max-width: 650px) {
	.third-to-full {
		width: 100%;
	}
	#serviceDetail .alt-custom {
		text-align: center;
	}
}
</style>